module.exports = __webpack_public_path__ + "img/丽江市人民医院.c63a9078.png";